import { ConfigurationTab, type ConfigurationTabEnum } from "@/features/sub-families/types";
import { type Locale, type Nullable, Site, type SiteEnum, WebComponentMode, type WebComponentModeEnum } from "@/types";

export const typedObjectEntries = <T extends object>(obj: T): [keyof T, NonNullable<T[keyof T]>][] => {
    return Object.entries(obj) as [keyof T, NonNullable<T[keyof T]>][];
};

export const typedObjectKeys = <T extends object>(obj: T): (keyof T)[] => {
    return Object.keys(obj) as (keyof T)[];
};

export const isDefined = <T>(value: T | undefined): value is T => typeof value !== "undefined";
export const isText = (value: unknown): value is string => typeof value === "string";
export const isNumber = (value: unknown): value is number => typeof value === "number";

export const isWebComponentMode = (value: unknown): value is WebComponentModeEnum => {
    return Object.values(WebComponentMode).includes(value as WebComponentModeEnum);
};

export const isConfigurationTab = (value: unknown): value is ConfigurationTabEnum => {
    return Object.values(ConfigurationTab).includes(value as ConfigurationTabEnum);
};

export const isSite = (value: unknown): value is SiteEnum => {
    return Object.values(Site).includes(value as SiteEnum);
};

export const isLocale = (value: Nullable<string>): value is Locale => {
    const [lang = "", country = ""] = value?.split("_") ?? [];

    const validLangLength = lang.length === 2;
    const validCountryLength = country.length === 2;
    const validCountryCase = country === country.toUpperCase(); // all chars need to be uppercase to be valid

    return validLangLength && validCountryLength === validCountryCase;
};
